import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { parse, stringify } from '../../utils/UrlUtil';

const messages = defineMessages({
  add: { id: 'menu.add_survey', defaultMessage: 'Add New Survey' },
});

class SurveyListHeader extends Component {
  constructor(props) {
    super(props);
    this.onQueryVariableChange = this.onQueryVariableChange.bind(this);
    this.onChangeQueryText = this.onChangeQueryText.bind(this);

    // extract initial state from URL
    const { location } = this.props;
    const params = parse(location.search);

    // Make sure initial state has some nice defaults
    this.state = {
      filter: Object.assign({}, params.filter),
    };
  }

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  onQueryVariableChange() {
    const { location, history } = this.props;
    const { filter } = this.state;

    const params = parse(location.search);

    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    // handle edge case for respondentType = ALL.
    if (newFilter.respondentType === 'ALL') {
      newFilter.respondentType = undefined;
    }

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  }

  /**
   * Update the filter Query.
   */
  onChangeQueryText(event) {
    const { filter } = this.state;
    this.setState({
      filter: {
        ...filter,
        query: event.currentTarget.value,
      },
    });
  }

  render() {
    const { filter } = this.state;
    const {
      currentAccount,
      history,
      intl: { formatMessage },
    } = this.props;

    return (
      <React.Fragment>
        <div className="p-grid">
          <div className="p-col">
            <div className="p-inputgroup">
              <InputText
                value={filter.query}
                onChange={this.onChangeQueryText}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') {
                    this.onQueryVariableChange();
                  }
                }}
              />
              <Button
                icon="pi pi-search"
                // For search we have a search button.
                // The state is already updated. We just upate the url
                onClick={this.onQueryVariableChange}
              />
            </div>
          </div>
          <div className="p-col align-right">
            <Button
              label={formatMessage(messages.add)}
              icon="fa fa-plus"
              onClick={() => history.push(`/accounts/${currentAccount}/respondents`)}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SurveyListHeader.propTypes = {
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    formatDate: PropTypes.func,
  }).isRequired,
  currentAccount: PropTypes.string.isRequired,
};

export default withRouter(injectIntl(SurveyListHeader));
